import {
  faArrowLeft,
  faMinusCircle,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Page from "../../component/Page";
import { getBranchList, getCatalogList } from "../setting/services/settingApi";
import { PLAN_CONFIG } from "./config";
import PlanContext from "./services/planApi";
import api from "../../api/api";
import ConfirmDialogPlandistribution from "./component/confirmDialogPlandistribution";
import ConfirmPlanPrint from "./component/confirmPlanPrint";
import Swal from "sweetalert2";

export default function ViewDistributionPlan() {
  const { profile, loading } = useSelector((state) => state.profile);
  const { id } = useParams();
  const navigate = useNavigate();
  const { getPlanSaleDetail } = useContext(PlanContext);
  const [detail, setDetail] = useState();
  const [year, setYear] = useState();
  const [open, setOpen] = useState(false);
  const [openP, setOpenP] = useState(false);
  const [remark, setRemark] = useState("");
  const [items, setItems] = useState([]);
  const [branchs, setBranchs] = useState([]);
  const [BranchNo, setBranchsNo] = useState("");
  const [yearError, setyearError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [version, setVersion] = useState('1');

  const [rows, setRows] = useState([
    {
      id: 0,
      GroupNo: null,
      CatalogNo: null,
      TargetMonth_1: "",
      TargetMonth_2: "",
      TargetMonth_3: "",
      TargetMonth_4: "",
      TargetMonth_5: "",
      TargetMonth_6: "",
      TargetMonth_7: "",
      TargetMonth_8: "",
      TargetMonth_9: "",
      TargetMonth_10: "",
      TargetMonth_11: "",
      TargetMonth_12: "",
    },
  ]);
  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      GroupNo: null,
      CatalogNo: null,
      TargetMonth_1: "",
      TargetMonth_2: "",
      TargetMonth_3: "",
      TargetMonth_4: "",
      TargetMonth_5: "",
      TargetMonth_6: "",
      TargetMonth_7: "",
      TargetMonth_8: "",
      TargetMonth_9: "",
      TargetMonth_10: "",
      TargetMonth_11: "",
      TargetMonth_12: "",
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e, index) => i !== index);
    setRows(data);
  };
  useEffect(() => {
    if (id) {
      getPlanSaleDetail(id, setDetail);
    }
    getCatalogList(null, setItems);
    getBranchList(null, setBranchs);
    setBranchsNo(profile?.BranchNo?.BranchNo);
  }, []);
  useEffect(() => {
    if (id) {
      setBranchsNo(detail?.BranchNo?.BranchNo);
      setYear(detail?.Year);
      setVersion(detail?.Version ? `${detail?.Version}` :'')
      setRemark(detail?.Remark);
      setRows(detail?.PlanDetails);
    }
  }, [detail]);

  const handleSubmit = () => {
    const body = {
      BranchNo: BranchNo,
      DocumentNo: id || null,
      DocumentDate: dayjs(new Date()).format("YYYY-MM-DD"),
      Year: year,
      Version: version,
      Remark: remark,
      PlanDetails: rows?.map((x) => ({
        ...x,
        CatalogNo: x?.CatalogNo?.CatalogNo,
        TargetMonth_1: +x?.TargetMonth_1.toString().replaceAll(",", "") || 0,
        TargetMonth_2: +x?.TargetMonth_2.toString().replaceAll(",", "") || 0,
        TargetMonth_3: +x?.TargetMonth_3.toString().replaceAll(",", "") || 0,
        TargetMonth_4: +x?.TargetMonth_4.toString().replaceAll(",", "") || 0,
        TargetMonth_5: +x?.TargetMonth_5.toString().replaceAll(",", "") || 0,
        TargetMonth_6: +x?.TargetMonth_6.toString().replaceAll(",", "") || 0,
        TargetMonth_7: +x?.TargetMonth_7.toString().replaceAll(",", "") || 0,
        TargetMonth_8: +x?.TargetMonth_8.toString().replaceAll(",", "") || 0,
        TargetMonth_9: +x?.TargetMonth_9.toString().replaceAll(",", "") || 0,
        TargetMonth_10: +x?.TargetMonth_10.toString().replaceAll(",", "") || 0,
        TargetMonth_11: +x?.TargetMonth_11.toString().replaceAll(",", "") || 0,
        TargetMonth_12: +x?.TargetMonth_12.toString().replaceAll(",", "") || 0,
      })),
    };

    const planSaleAdd = async () => {
      setIsLoading(true);
      if (id) {
        const url =
          PLAN_CONFIG.requests.getPlanSale.url + `/${body?.DocumentNo}`;
        const res = await api.put(url, body);
        const data = res.data;
        if (data.status === true) {
          setOpen(false);
          setOpenP(true);
          getPlanSaleDetail(id, setDetail);
          setIsLoading(false);
        }
      } else {
        const res = await api.post(PLAN_CONFIG.requests.getPlanSale.url, body);
        const data = res.data;
        if (data.status === true) {
          navigate("/plan/distribution-plan/" + data.result.DocumentNo);
          setIsLoading(false);
          setOpen(false);
          setOpenP(true);
        } else {
          Swal.fire({
            title: data?.message || "ทำรายการไม่สำเร็จ",
            icon: "warning",
          });
          setIsLoading(false);
        }
      }
    };
    planSaleAdd();
  };

  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <form>
          <div class="container-fluid">
            <div class="d-flex row align-items-center ">
              <div class="col-12">
                <label class="title-content mb-4">ข้อมูลแผนการจำหน่าย</label>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <FormControl variant="standard" fullWidth>
                    <Select
                      value={BranchNo || ""}
                      onChange={(e) => setBranchsNo(e.target.value)}
                      disableUnderline
                    >
                      {branchs?.map((x) => (
                        <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div class="col-lg-4 col-md-6">
                <label class="labelInput">ปีงบประมาณ</label>
                <Box className={`backgroundField ${yearError ? "error" : ""}`}>
                  <TextField
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    variant="standard"
                    fullWidth
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setyearError(true);
                      } else {
                        setyearError(false);
                      }
                    }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
                {yearError && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    กรุณาเลือกปีงบประมาณ
                  </span>
                )}
              </div>
              <div class="col-lg-4 col-md-6 row align-items-center">
                <RadioGroup
                  value={version ||''}
                  onChange={(e) => setVersion(e.target.value)}
                  row
                >
                  <FormControlLabel
                    value="1"
                    disabled={id}
                    control={<Radio />}
                    label="ครั้งที่ 1 (ต.ค. - ก.ย.)"
                  />
                  <FormControlLabel
                    value="2"
                    disabled={id}
                    control={<Radio />}
                    label="ครั้งที่ 2 (เม.ย. - ก.ย.)"
                  />
                 
                </RadioGroup>
              </div>
            </div>
            {id && (
              <div class="row">
                <div class="col-lg-4 col-md-6">
                  <label class="labelInput me-3">ผู้สร้าง</label>{" "}
                  <label class="message-error-label">
                    ( {dayjs(detail?.CreateDate).format("DD/MM/BBBB")} )
                  </label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled
                      value={detail?.CreateId}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-6">
                  <label class="labelInput me-3">ผู้แก้ไข</label>{" "}
                  <label class="message-error-label">
                    ( {dayjs(detail?.ModifiedDate).format("DD/MM/BBBB")} )
                  </label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled
                      value={detail?.ModifiedId}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
              </div>
            )}
            <div class="row">
              <div class="col-lg-8 col-md-12">
                <label class="labelInput">หมายเหตุ</label>
                <Box
                  className="backgroundField"
                  sx={{ marginBottom: "10px", borderRadius: "25px" }}
                >
                  <TextField
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    variant="standard"
                    fullWidth
                    multiline
                    rows={3}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="d-flex row align-items-center  mt-5 mb-4">
              <div class="col-6">
                <label class="title-content">รายการแผนการจำหน่าย</label>
              </div>
              <div class="col-6 text-end">
                <FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 table-responsive-sm pb-3"
                style={{ height: "auto" }}
              >
                <table class="table table-borderless table-hover ">
                  <thead>
                    <tr>
                      <th scope="col ">ที่</th>
                      <th scope="col ">พันธุ์ข้าว</th>
                      <th scope="col ">ต.ค.</th>
                      <th scope="col ">พ.ย.</th>
                      <th scope="col ">ธ.ค.</th>
                      <th scope="col ">ม.ค.</th>
                      <th scope="col ">ก.พ.</th>
                      <th scope="col ">มี.ค.</th>
                      <th scope="col ">เม.ย.</th>
                      <th scope="col ">พ.ค.</th>
                      <th scope="col ">มิ.ย.</th>
                      <th scope="col ">ก.ค.</th>
                      <th scope="col ">ส.ค.</th>
                      <th scope="col ">ก.ย.</th>
                      <th scope="col ">รวม</th>
                      <th scope="col ">หน่วย</th>
                      <th scope="col "></th>
                    </tr>
                  </thead>
                  <tbody class="">
                    {rows?.map((x, i) => (
                      <tr>
                        <td class="text-center">{i + 1}.</td>
                        <td>
                          <Autocomplete
                            size="small"
                            // readOnly={id ? true : false}
                            options={items}
                            getOptionLabel={(option) => option?.CatalogName}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: 300,
                                },
                              },
                            }}
                            // renderOption={(props, option) => (
                            //     <Box component="li" {...props} key={option.ItemNo}>
                            //         {option?.CatalogNo?.CatalogName} {option?.Option2} {option?.Season} {option?.Option1} {option?.Chemical}
                            //     </Box>
                            // )}
                            value={x?.CatalogNo}
                            onChange={(event, newValue) => {
                              const item = rows?.map((v, index) => {
                                v.CatalogNo =
                                  i === index ? newValue : v?.CatalogNo;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            renderInput={(params) => (
                              <Box ref={params.InputProps.ref}>
                                <OutlinedInput
                                  {...params.inputProps}
                                  fullWidth
                                  size="small"
                                  sx={{ padding: "0 !important" }}
                                />
                              </Box>
                            )}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_10.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_10 =
                                  i === index ? abc : v?.TargetMonth_10;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_11.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_11 =
                                  i === index ? abc : v?.TargetMonth_11;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_12.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_12 =
                                  i === index ? abc : v?.TargetMonth_12;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_1.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_1 =
                                  i === index ? abc : v?.TargetMonth_1;
                                return v;
                              });
                              setRows([...item]);
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_2.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_2 =
                                  i === index ? abc : v?.TargetMonth_2;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_3.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_3 =
                                  i === index ? abc : v?.TargetMonth_3;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_4.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_4 =
                                  i === index ? abc : v?.TargetMonth_4;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_5.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_5 =
                                  i === index ? abc : v?.TargetMonth_5;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_6.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_6 =
                                  i === index ? abc : v?.TargetMonth_6;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_7.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_7 =
                                  i === index ? abc : v?.TargetMonth_7;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_8.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_8 =
                                  i === index ? abc : v?.TargetMonth_8;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          <TextField
                            value={x?.TargetMonth_9.toLocaleString()}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = rows?.map((v, index) => {
                                v.TargetMonth_9 =
                                  i === index ? abc : v?.TargetMonth_9;
                                return v;
                              });
                              setRows([...item]);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          {parseFloat(
                            +x?.TargetMonth_1.toString().replaceAll(",", "") +
                              +x?.TargetMonth_2.toString().replaceAll(",", "") +
                              +x?.TargetMonth_3.toString().replaceAll(",", "") +
                              +x?.TargetMonth_4.toString().replaceAll(",", "") +
                              +x?.TargetMonth_5.toString().replaceAll(",", "") +
                              +x?.TargetMonth_6.toString().replaceAll(",", "") +
                              +x?.TargetMonth_7.toString().replaceAll(",", "") +
                              +x?.TargetMonth_8.toString().replaceAll(",", "") +
                              +x?.TargetMonth_9.toString().replaceAll(",", "") +
                              +x?.TargetMonth_10.toString().replaceAll(
                                ",",
                                ""
                              ) +
                              +x?.TargetMonth_11.toString().replaceAll(
                                ",",
                                ""
                              ) +
                              +x?.TargetMonth_12.toString().replaceAll(",", "")
                          )
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </td>
                        <td class="text-center">กิโลกรัม</td>
                        <td>
                          <FontAwesomeIcon
                            icon={faMinusCircle}
                            onClick={() => deletehand(i)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <hr class="chr" />
            <div class="row mt-4">
              <div class="col-12 ">
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                  sx={{ width: "130px", fontSize: "14px", marginRight: "10px" }}
                >
                  กลับ
                </Button>
                <Button
                  variant="contained"
                  sx={{ width: "130px", fontSize: "14px" }}
                  onClick={() => {
                    if (!year) {
                      setyearError(true);
                    } else {
                      setOpen(true);
                    }
                  }}
                >
                  {id ? "เเก้ไข" : "บันทึก"}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </Page>
      <ConfirmDialogPlandistribution
        open={open}
        setOpen={setOpen}
        rows={rows}
        handleAdd={handleSubmit}
        isLoading={isLoading}
      />
      <ConfirmPlanPrint
        title={"บันทึกรายการแผนการจำหน่ายสำเร็จ"}
        download={null}
        open={openP}
        setOpen={setOpenP}
        loadingPDF={null}
        linkTo="/plan/distribution-plan/add"
      />
    </div>
  );
}
